/**
 * @flow
 * @relayHash ef97d9713fa6649221d8891ffac3f023
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type HeartDonationCampaignContainer_app$ref = any;
type HeartDonationCampaignContainer_user$ref = any;
export type CampaignBaseQueryVariables = {|
  userId: string,
  charityId: string,
  startTime: string,
  endTime: string,
|};
export type CampaignBaseQueryResponse = {|
  +app: ?{|
    +$fragmentRefs: HeartDonationCampaignContainer_app$ref
  |},
  +user: ?{|
    +$fragmentRefs: HeartDonationCampaignContainer_user$ref
  |},
|};
export type CampaignBaseQuery = {|
  variables: CampaignBaseQueryVariables,
  response: CampaignBaseQueryResponse,
|};
*/


/*
query CampaignBaseQuery(
  $userId: String!
  $charityId: String!
  $startTime: String!
  $endTime: String!
) {
  app {
    ...HeartDonationCampaignContainer_app_3uKjWt
    id
  }
  user(userId: $userId) {
    ...HeartDonationCampaignContainer_user
    id
  }
}

fragment HeartDonationCampaignContainer_app_3uKjWt on App {
  charity(charityId: $charityId) {
    id
    name
    vcReceived(startTime: $startTime, endTime: $endTime)
    ...DonateHeartsControlsContainer_charity
  }
}

fragment HeartDonationCampaignContainer_user on User {
  vcCurrent
  ...DonateHeartsControlsContainer_user
}

fragment DonateHeartsControlsContainer_user on User {
  id
  vcCurrent
}

fragment DonateHeartsControlsContainer_charity on Charity {
  id
  image
  imageCaption
  impact
  name
  website
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "charityId",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "startTime",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "endTime",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId",
    "type": "String!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "CampaignBaseQuery",
  "id": null,
  "text": "query CampaignBaseQuery(\n  $userId: String!\n  $charityId: String!\n  $startTime: String!\n  $endTime: String!\n) {\n  app {\n    ...HeartDonationCampaignContainer_app_3uKjWt\n    id\n  }\n  user(userId: $userId) {\n    ...HeartDonationCampaignContainer_user\n    id\n  }\n}\n\nfragment HeartDonationCampaignContainer_app_3uKjWt on App {\n  charity(charityId: $charityId) {\n    id\n    name\n    vcReceived(startTime: $startTime, endTime: $endTime)\n    ...DonateHeartsControlsContainer_charity\n  }\n}\n\nfragment HeartDonationCampaignContainer_user on User {\n  vcCurrent\n  ...DonateHeartsControlsContainer_user\n}\n\nfragment DonateHeartsControlsContainer_user on User {\n  id\n  vcCurrent\n}\n\nfragment DonateHeartsControlsContainer_charity on Charity {\n  id\n  image\n  imageCaption\n  impact\n  name\n  website\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "CampaignBaseQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "app",
        "storageKey": null,
        "args": null,
        "concreteType": "App",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "HeartDonationCampaignContainer_app",
            "args": [
              {
                "kind": "Variable",
                "name": "endTime",
                "variableName": "endTime",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "startTime",
                "variableName": "startTime",
                "type": null
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "HeartDonationCampaignContainer_user",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "CampaignBaseQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "app",
        "storageKey": null,
        "args": null,
        "concreteType": "App",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "charity",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "charityId",
                "variableName": "charityId",
                "type": "String!"
              }
            ],
            "concreteType": "Charity",
            "plural": false,
            "selections": [
              v2,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "vcReceived",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "endTime",
                    "variableName": "endTime",
                    "type": "String"
                  },
                  {
                    "kind": "Variable",
                    "name": "startTime",
                    "variableName": "startTime",
                    "type": "String"
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "image",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "imageCaption",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "impact",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "website",
                "args": null,
                "storageKey": null
              }
            ]
          },
          v2
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "vcCurrent",
            "args": null,
            "storageKey": null
          },
          v2
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6bdad5779a2fa23ae7c07d54d7e496dc';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Campaign/__generated__/CampaignBaseQuery.graphql.js